export default __webpack_public_path__ + "static/media/ellipseIcon.a78a9e0a.svg";